import React, { useState } from 'react';
import _ from 'lodash';
import { useUser } from '../../../../contexts/user.context';
import { useForm } from 'react-hook-form';
import SaveButton from '../../../../components/SaveButton';
import { mobilizeiStoresService } from '../../../../services/mobilizei/stores.service';
import { showApiError } from '../../../../utils/errors';
import { toast } from 'react-toastify';
import DunsNumber from './DunsNumber';
import GoogleAccount from './GoogleAccount';
import AppleAccount from './AppleAccount';
import { Box } from '@mui/material';

export default function DeveloperAccounts() {
  const { user, setUser } = useUser();

  const [isLoading, setIsLoading] = useState(false);

  const { handleSubmit, reset, register, formState: { errors, isDirty } } = useForm({
    defaultValues: {
      dunsNumber: user?.store?.dunsNumber || '',
      developerAccountEmail: user?.store?.platforms?.android?.developerAccountEmail || '',
      developerAccountName: user?.store?.platforms?.android?.developerAccountName || '',
      teamName: user?.store?.platforms?.ios?.teamName || '',
      teamID: user?.store?.platforms?.ios?.teamID || ''
    }
  });

  const onSubmit = (data) => {
    if (!data) {
      return
    }

    setIsLoading(true)

    let dataToPost = {
      dunsNumber: data.dunsNumber,
      platforms: {
        android: {
          developerAccountEmail: data.developerAccountEmail,
          developerAccountName: data.developerAccountName
        },
        ios: {
          teamName: data.teamName,
          teamID: data.teamID
        }
      }
    }

    mobilizeiStoresService.updateStoreById(user?.store?.platformId, user?.store?.id, dataToPost)
      .then(() => {
        toast.success('Alterações salvas com sucesso!');

        // Update the local user data to match the data that was 
        // updated on the backend
        setUser({
          ...user,
          store: {
            ...user?.store,
            dunsNumber: data.dunsNumber,
            platforms: {
              ...user?.store?.platforms,
              android: {
                ...user?.store?.platforms?.android,
                developerAccountEmail: data.developerAccountEmail,
                developerAccountName: data.developerAccountName
              },
              ios: {
                ...user?.store?.platforms?.ios,
                teamName: data.teamName,
                teamID: data.teamID
              }
            }
          }
        });

        // Calling the reset function with an object will update the form defaultValues 
        // and subsequent calls to reset() will use the new default values
        reset(data);
      }).catch(e => {
        showApiError(e.error);
      })
      .finally(() => {
        setIsLoading(false);
      })
  }

  return (
    <Box mb={14}>
      <DunsNumber
        errors={errors}
        register={register}
      />

      <GoogleAccount
        errors={errors}
        register={register}
      />

      <AppleAccount
        errors={errors}
        register={register}
      />

      <SaveButton
        isLoading={isLoading}
        onCancel={() => reset()}
        show={isDirty}
        onClick={handleSubmit(onSubmit)}
      />
    </Box>
  );
}